import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Bookmark, StickyNote, ArrowRight } from "lucide-react";

export function SavedLessons({ modules, meta }) {
  const index = {};
  (modules || []).forEach((m) =>
    (m.lessons || []).forEach((l) => {
      index[l.id] = { moduleId: m.id, moduleNumber: m.number, lessonTitle: l.title };
    })
  );

  const items = Object.entries(meta || {})
    .map(([lessonId, v]) => ({ lessonId, ...v, ...index[lessonId] }))
    .filter((it) => it.lessonTitle && (it.bookmarked || it.note))
    .sort((a, b) => (b.updated_at || "").localeCompare(a.updated_at || ""));

  if (items.length === 0) return null;

  return (
    <motion.section
      data-testid="saved-lessons-section"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mt-10"
    >
      <div className="flex items-center gap-2 mb-4">
        <Bookmark className="h-5 w-5 text-gold" />
        <h2 className="font-heading font-bold text-2xl">Lesezeichen & Notizen</h2>
        <span className="text-sm text-muted-foreground">({items.length})</span>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {items.map((it) => (
          <Link
            key={it.lessonId}
            to={`/module/${it.moduleId}/lesson/${it.lessonId}`}
            data-testid={`saved-item-${it.lessonId}`}
            className="group rounded-2xl glass p-5 hover:glow-gold transition-all duration-300 flex flex-col"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-mono text-xs text-gold">Modul {String(it.moduleNumber).padStart(2, "0")}</div>
                <div className="font-medium mt-1 group-hover:text-gold transition-colors truncate">{it.lessonTitle}</div>
              </div>
              {it.bookmarked && <Bookmark className="h-4 w-4 text-gold flex-shrink-0 fill-gold" />}
            </div>
            {it.note && (
              <div className="mt-3 flex items-start gap-2 text-sm text-foreground/70">
                <StickyNote className="h-4 w-4 text-amber-glow flex-shrink-0 mt-0.5" />
                <p className="line-clamp-2 leading-relaxed">{it.note}</p>
              </div>
            )}
            <div className="mt-3 inline-flex items-center gap-1 text-xs text-muted-foreground group-hover:text-gold transition-colors">
              Zur Lektion <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </motion.section>
  );
}

export default SavedLessons;
